import { AccountFeatures } from "@lightspeed-invoicing/core-client/frontend"
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context"
import Product from '@lightspeed-invoicing/core-client/frontend/app/api/models/Product.js'
import React, { Component } from 'react'
import { FormattedMessage, FormattedNumber, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Guard, Permissions } from "../../role/Guard.jsx"
import FormattedInputField from "../../sharedComponents/formattedInputField.component.jsx"
import { DISCOUNT_TYPE } from '../../state/pricing/DiscountType'
import { deletePricingTableItem, patchPricingTableItem, putPricingTableItemDiscount } from '../../state/pricing/actions'
import {
    getPricingTableId,
    isBottomPriceEnabled
} from "../../state/pricing/selectors"
import GlobalHelper from "../GlobalHelper.jsx"
import Icon from "../icon/icon.component.jsx"
import CommitmentDurationLabel from "../pricing/commitmentdurationlabel.component.jsx"
import LabelAmountPerUnitOfMeasure from '../unit-of-measure/perunit.component.jsx'

class QuoteItemPrice extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            item: this.props.value || null,
            addedInputClass: this.props.addedInputClass ?? "",
            type: this.props.type || 'quote',
            editable: this.props.editable && Guard.isAuthorized(Permissions.OverwriteTotalPricePerLine),
            editMode: false,
            manualSubtotalAmount: this.props.value ? (!this.props.value.attributes.isTaxInclusive ?
                this.props.value.attributes.subtotalAmount : this.props.value.attributes.subtotalAmountInclusive) : '',
            onChange: this.props.onChange || function () { },
        }
        this.triggerEdit = this.triggerEdit.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
        this.shouldDisplayBottomPrice = this.shouldDisplayBottomPrice.bind(this)
        this.save = this.save.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            item: nextProps.value,
            type: nextProps.type || 'quote',
            editable:nextProps.editable,
        })
    }

    triggerEdit(event) {
        event.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    async save(event) {
        event.preventDefault()

        await this.props.putPricingTableItemDiscount(this.props.itemId, this.props.mainObjectId, this.props.type, {
            discountType: DISCOUNT_TYPE.DISCOUNT_PERCENT_BEFORE_TAXES,
            discountValue: "0",
            mainObjectId: this.state.mainObjectId,
        } )
            
        this.props.dispatch(patchPricingTableItem(this.props.value.id, this.props.mainObjectId,this.state.type, {
            manualSubtotalAmount: this.state.manualSubtotalAmount,
            mainObjectId: this.props.mainObjectId,
        }, true, true))
        
        
       

        if (this.props.onChange) {
            this.state.onChange(r)
        }
        this.triggerEdit(event)

    }

    handleFocus(event) {
        event.target.select()
    }

    getSubtotalAmount() {
        return (!this.state.item.attributes.isTaxInclusive || !this.state.item.attributes.taxable) ?
            this.state.item.attributes.subtotalAmount : this.state.item.attributes.subtotalAmountInclusive
    }

    getSubTotalBottomPrice(){
        return (!this.state.item.attributes.isTaxInclusive || !this.state.item.attributes.taxable) ?
            this.state.item.attributes.subtotalBottomPrice : this.state.item.attributes.subtotalBottomPriceInclusive
    }

    shouldDisplayBottomPrice = () =>{
        const isFeatureEnabled = AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureBottomLinePrice)
        return this.getSubTotalBottomPrice() > 0  && this.props.isBottomPriceEnabled && isFeatureEnabled
    }

    render () {
        if (!this.state.item || !this.state.item.attributes) {
            return ''
        }

        let price = <FormattedNumber
            style="currency"
            currency={this.state.item.attributes.currency}
            value={this.getSubtotalAmount()}
        />

        if (this.state.item.attributes.type === "extra-fee") {
            price = <LabelAmountPerUnitOfMeasure
                currency={this.state.item.attributes.currency}
                value={this.state.item.attributes.totalUnitPrice}
                unit={this.state.item.attributes.unitOfMeasure}
            />
            if (["bracket-custom", "bracket"].includes(this.state.item.attributes.itemObject.attributes.pricingStrategy)) {
                let product = new Product(this.state.item.attributes.itemObject)
                price = <FormattedMessage
                    id="common.quote.item.price.from_price_label"
                    defaultMessage="from {price}"
                    values={{
                        'price': <FormattedNumber
                            style="currency"
                            currency={this.state.item.attributes.currency}
                            value={product.getMinimumPrice()}
                        />
                    }}
                />
            }
        }

        if (this.state.editMode && this.state.editable) {
            price = <div >
                <p className="m-0" >
                    <FormattedInputField
                        type="text"
                        className={"form-control " + this.state.addedInputClass}
                        placeholder={GlobalHelper.applyLocaleDecimal("0.00", AppContext.getLocale().getLanguage())}
                        onFocus={this.handleFocus}
                        valueType="money"
                        value={this.state.manualSubtotalAmount}
                        onValueChange={(newValue) => { this.setState({ manualSubtotalAmount: newValue }) }}
                    />
                </p>
                <p className="m-0 pt-2">
                    <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                        <Icon value={"arrow-left"} />
                    </button>
                    <button className="btn btn-sm btn-outline-primary ml-2" onClick={this.save}>
                        <Icon value={"save"} />
                    </button>
                </p>

            </div>
        } else if (this.state.editable) {
            const lines = []
            lines.push(<p className="m-0" key={lines.length}>
                <a href="#" onClick={this.triggerEdit}>
                    <FormattedNumber
                        style="currency"
                        currency={this.state.item.attributes.currency}
                        value={this.getSubtotalAmount()}
                    />
                </a>
            </p>)
            if (this.state.item.attributes.billingMethod === "monthly") {
                lines.push(<p className="m-0" key={lines.length}>
                    <small><em>
                        <FormattedMessage
                            id="common.quote.item.price.per_month_label"
                            defaultMessage="per month"
                        />
                    </em></small>
                </p>)
            }
            if (this.state.item.attributes.billingMethod === "yearly") {
                lines.push(<p className="m-0" key={lines.length}>
                    <small><em>
                        <FormattedMessage
                            id="common.quote.item.price.per_year_label"
                            defaultMessage="per year"
                        />
                    </em></small>
                </p>)
            }
            if (this.state.item.attributes.commitmentDuration > 0 &&
                (this.state.billingMethod && this.state.billingMethod === 'recurring')) {
                lines.push(<p className="m-0" key={lines.length}>
                    <small><em>
                        (<CommitmentDurationLabel
                            value={this.state.item.attributes.commitmentDuration}
                            billingMethod={this.state.item.attributes.billingMethod}
                        />)
                    </em></small>
                </p>)
            }
            if (this.shouldDisplayBottomPrice()){
                lines.push(<p className="m-0">
                    <small><em>
                        <Icon value="arrow-circle-down"/>
                        <FormattedNumber
                            style="currency"
                            currency={this.state.item.attributes.currency}
                            value={this.getSubTotalBottomPrice()}
                        />
                    </em></small>
                </p>)
            }
            return lines
        }

        if (this.state.item.attributes.subtotalAmount < 0) {
            price = <div className="text-warning"> {price} </div>
        }
        return price
    }

}
const mapState = (state, props) => {
    let id = props.mainObjectId
    return {
        ...props,
        pricingTableId: getPricingTableId(state, id),
        isBottomPriceEnabled: isBottomPriceEnabled(state)
        
    }
}
const mapDispatch = (dispatch) => { 
    return {
    putPricingTableItemDiscount : putPricingTableItemDiscount, 
    deletePricingTableItem : deletePricingTableItem, 
    dispatch : dispatch }

}
export default connect(mapState, mapDispatch)(injectIntl(QuoteItemPrice))






// WEBPACK FOOTER //
// ./src/common/quote/itemprice.component.jsx